import Vue from "vue";
import VueRouter from "vue-router";
// Guard
import { defaultGuard, privateGuard } from "@/middlewares/guards";
// Layouts
import LoginLayout from "../layouts/LoginLayout.vue";
import NavLayout from "../layouts/NavLayout.vue";
// Views
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
// Module routes
import productionRoutes from "@/router/production.routes";
import ordersRoutes from "@/router/orders.routes";
import logisticRoutes from "@/router/logistic.routes";
import cepariumRoutes from "@/router/ceparium.routes";
import qualityRoutes from "@/router/quality.routes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: LoginLayout,
    beforeEnter: defaultGuard,
    children: [
      {
        path: "",
        name: "Login",
        component: Login,
        meta: {
          title: "Inicio de sesión",
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          title: "Dashboard",
        },
      },
    ],
  },
  ...productionRoutes,
  ...ordersRoutes,
  ...logisticRoutes,
  ...cepariumRoutes,
  ...qualityRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const DEFAULT_TITLE = "Solena producción";
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
